<script>
/**
 * ****************************************************************************
 * @description     :   Main component for popup M903_201
 * @created at      :   2024/05/22
 * @created by      :   ANS903 – phuongdt@ans-asia.com
 * @package         :   Move
 * @copyright       :   Copyright (c) A.N.S Asia
 * @version         :   1.0.0
 * ****************************************************************************
 */

/**
 * Import template
 */
import template from './template.html';
import { mapActions, mapMutations, mapState } from 'vuex';
import AnsButton from '@/components/ansButton/index.vue';
import messages from '@/utils/messages';
/**
 * Define component for popup Fab040120i
 */
var M903_201 = {
    components: { AnsButton },
    template: template,
    props: {
        onSelected: Function,
        id: String,
        initData: [String, Number],
        isShowFooter: Boolean
    },
    created() {
        this.onSearchItem();
    },
    data() {
        return {
            searchResult: [],
            searchParams: {
                item_code: '',
                item_name: '',
                page_size: 10,
                page_no: 1
            },
            msgNoData: '',
            paging: {}
        };
    },
    emits: ['close'],
    computed: {
        ...mapState('M903_201', ['data'])
    },
    methods: {
        ...mapMutations('app', ['showHeaderError', 'showModalMessage']),
        ...mapMutations('M903_201', ['updateItem']),
        ...mapActions('M903_201', ['searchItem']),
        onSearchItem() {
            this.search(this.searchParams);
        },
        search(data) {
            this.searchItem({
                body: {
                    ...data
                },
                callback: (response) => {
                    if (response.Data.data.length) {
                        this.searchResult = response.Data.data;
                        this.paging = response.Data.paging[0];
                        this.msgNoData = '';
                    } else {
                        this.msgNoData = '該当するデータが存在しません。';
                        this.searchResult = [];
                        this.paging = {};
                    }
                },
                onError: (errorMessage) => {
                    this.showHeaderError([errorMessage ?? messages.E999]);
                }
            });
        },
        changeCurrentPage(data) {
            this.search({
                ...this.searchParams,
                page_size: data.perPage,
                page_no: data.currentPage
            });
        },
        chooseItem(item) {
            this.updateItem({
                id: this.id,
                item_id: item.item_id,
                item_code: item.item_code,
                item_name: item.item_name
            });
            this.$emit('close');
        }
    }
};
export default M903_201;
</script>
